/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
(function() {
  // Toggle debugging logs
  const isDebug = false;
  const baseStyles = [
    "color: #444",
    "background-color: #A2E4B8",
    "padding: 2px 8px",
    "border-radius: 4px"
  ].join(";");
  function consoleLog() {
    if (window.console && isDebug === true) {
      console.log('%cBF', baseStyles, ...Array.prototype.slice.call(arguments));
    }
  };

  const reviewsByProduct = {
    // lip sore cream
    "42306110357644": {
      "stars": 4.83,
      "qty": 29,
    },
    // manuka
    "42306050457740": {
      "stars": 4.58,
      "qty": 147,
    },
    // usr
    "42306031681676": {
      "stars": 4.59,
      "qty": 229,
    },
    // shs
    "42306099642508": {
      "stars": 4.81,
      "qty": 37,
    },
    // baby to granny
    "41025793360012": {
      "stars": 4.69,
      "qty": 111,
    },
    // csc chronic skin care
    "41025761771660": {
      "stars": 4.8,
      "qty": 147,
    },
    // kids2
    "41541910298764": {
      "stars": 5,
      "qty": 13,
    },
    // kits manuka
    "42306178252940": {
      "stars": 5,
      "qty": 4,
    },
    // gift card
    // "43274403414156": {
    // }
  }

  // bundle builder widget
  if (window.bundler_builders && window.bundler_builders.some(builder => document.body.id === builder)) {
  // if (document.body.id === 'black-friday-bundler' || document.body.id === 'bio-first-routine-bundle-builder') {
    document.addEventListener('DOMContentLoaded', function() {
      const checkForReamazeElement = setInterval(() => {
        const reamazeElement = document.querySelector('#reamazejs-container');
        if (reamazeElement) {
          clearInterval(checkForReamazeElement);
          reamazeElement.style.display = 'none';
        }
      }, 100);

      const checkForElement = setInterval(() => {
        const element = document.querySelector('.bndlr-mnm-available-products');
        if (element) {
          clearInterval(checkForElement);
          consoleLog('BF - .bndlr-mnm-available-products exists');
          // Add your code here to execute when the element exists

          const products = element.querySelectorAll('.bndlr-mnm-available-products .bndlr-product.bndlr-mix-and-match'); 
          products.forEach(product => {
            consoleLog('BF - product:', product);
            const productId = product.getAttribute('data-product-id');
            if (reviewsByProduct.hasOwnProperty(productId)) {
              const review = reviewsByProduct[productId];
              if (review.stars && review.qty) {
                const reviewElement = document.createElement('div');
                reviewElement.className = 'jdgm-preview-badge';
                reviewElement.innerHTML = `
                  <span class="jdgm-prev-badge__stars" data-score="${review.stars}" tabindex="0">${'<span class="jdgm-star jdgm--on"></span>'.repeat(Math.floor(review.stars))}${review.stars % 1 ? '<span class="jdgm-star jdgm--half"></span>' : ''}</span>
                  <div class="qty">${review.qty} reviews</div>
                `;
                const priceElement = product.querySelector('.bndlr-product-price');
                if (priceElement) {
                  priceElement.parentNode.insertBefore(reviewElement, priceElement.nextSibling);
                }
              }
            }

            const titleElement = product.querySelector('.bndlr-product-title');
            if (titleElement) {
              const title = titleElement.textContent;
              consoleLog('BF - title:', title);
              if (title.includes(' - Set of 1')) {
                titleElement.textContent = title.replace(' - Set of 1', '').trim();
              }
              if (title.includes(' - Set of 2')) {
                titleElement.textContent = title.replace(' - Set of 2', '').trim();
              }
            }
          });

          const instructionsTextElement = document.querySelector('.bndlr-tiered-mnm-instructions-text-inner');
          if (instructionsTextElement) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'characterData' || mutation.type === 'childList') {
                  consoleLog('BF - Instructions text changed:', instructionsTextElement.textContent);

                  if (instructionsTextElement.textContent.includes('item(s) to get up to')) {
                    instructionsTextElement.textContent = instructionsTextElement.textContent.replace('item(s) to get up to', 'item for');
                  }
                }
              });
            });

            observer.observe(instructionsTextElement, {
              characterData: true,
              childList: true,
              subtree: true
            });
          }

          const instructionsTextFirstElement = document.querySelector('.bndlr-mnm-instructions-text');
          if (instructionsTextFirstElement) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'characterData' || mutation.type === 'childList') {
                  consoleLog('BF - First instructions text changed:', instructionsTextFirstElement.textContent);

                  if (instructionsTextFirstElement.textContent.includes('Your bundle needs 1 more item(s).')) {
                    instructionsTextFirstElement.textContent = instructionsTextFirstElement.textContent.replace('Your bundle needs 1 more item(s).', 'Add 1 more item for 10% OFF!');
                  }
                }
              });
            });

            observer.observe(instructionsTextFirstElement, {
              characterData: true,
              childList: true,
              subtree: true
            });
          }

          const selectedProductsTitle = document.querySelector('.bndlr-mnm-selected-products-title');
          if (selectedProductsTitle) {
            selectedProductsTitle.addEventListener('click', function() {
              const secondContainer = document.querySelector('.bndlr-mnm-second-container');
              if (secondContainer && secondContainer.classList.contains('minimized')) {
                secondContainer.classList.remove('minimized');
                selectedProductsTitle.textContent = "Added To Your Bundle";
              } else {
                secondContainer.classList.add('minimized');
                selectedProductsTitle.textContent = "Tap to view your bundle";
              }
              
            });
          }

          const addToBundleButtons = document.querySelectorAll('.bndlr-add-to-bundle');
          addToBundleButtons.forEach(button => {
            button.addEventListener('click', function() {
              if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                setTimeout(() => {
                  window.scrollBy(0, 2);
                  setTimeout(() => {
                    window.scrollBy(0, -2);
                  }, 10);
                }, 0);
              }
            });
          });

        }
      }, 100);
    });
  }

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     consoleLog('Container ———————— ↓');
  //     consoleLog(container);
  //     consoleLog('Variant —————————— ↓');
  //     consoleLog(variant);
  //     // ... update some element on the page
  //   }
  // });

  document.addEventListener('theme:cart:init', function(event) {
    // Check every 100ms until window.isMonkUpsellInitDone !== undefined
    const checkIsMonkUpsellInitDone = setInterval(() => {
      if (window.isMonkUpsellInitDone !== undefined) {
        // Your code here
        consoleLog('BF - Cart - Monk loaded, reloading cart');
        window.mrload();
        document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }));

        try {
          window.dataLayer = window.dataLayer || [];

          if (gtag !== undefined) {
            consoleLog('BF - Cart - gtag submitted');
            gtag('event', 'screen_view', {
              'app_name': 'Monk',
              'screen_name': 'Cart Viewed'
            });
          }
        } catch (error) {
          consoleLog('BF - Cart - Error loading gtag');
          consoleLog(error);
        }

        clearInterval(checkIsMonkUpsellInitDone);
      }
    }, 100);
  });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   consoleLog('theme:cart:init');
  //   consoleLog(e);
  // });
  
  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { consoleLog(e); });
  // document.addEventListener('theme:scroll:up', e => { consoleLog(e); });
  // document.addEventListener('theme:scroll:down', e => { consoleLog(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { consoleLog(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  
})();
